import { Component } from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "../../translate/translate.service";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
				<loading [isLoad]="isLoad"></loading>
				<table class="table">
					<thead>
						<tr>
							<th>
								{{ 'adminstat.mails.mail_ga.mail' | translate }}
							</th>
							
							<th>
								{{ 'adminstat.mails.mail_ga.sends count' | translate }}
							</th>
							
							<th>
								{{ 'adminstat.mails.mail_ga.open count' | translate }}
							</th>
							
							<th>
								{{ 'adminstat.mails.mail_ga.open rate' | translate }} %
							</th>
						</tr>
					</thead>
					
					<tbody>
						<tr *ngFor="let stat of stats">
							<td>
								{{ 'adminstat.mails.mail.' + stat.name | translate }}
							</td>
							
							<td>
								{{ stat.sent }}
							</td>
							
							<td>
								{{ stat.read }} 
							</td>
							
							<td>
								{{ stat.proc || 0 }} %
							</td>
						</tr>
					</tbody>
				</table>
			</info-modal>
	`
})
export class MailDetailComponent extends InfoModalComponent {
	isLoad: boolean = false;
	status: string = 'Active';
	
	public stats = [];
	
	constructor(public activeModal: NgbActiveModal, public translate: TranslateService) {
		super(activeModal);
	}
	
	
	ok() {
		this.close();
	}
}
